import React from "react"
import { Button } from "reactstrap"
import { withBasicNotify } from "components/notification"

import noImage from "assets/images/no-image.jpg"

const ShoppingCartItem = props => {
  const { index, orderDetail, updateCartQuantity, updateToCart } = props

  const checkQuantity = quantity => {
    if (quantity <= 0) {
      props.notify.warn("商品數量不可小於1")
      return false
    }

    return true
  }

  return (
    <div className="product-item">
      <div className="column-value image-block">
        <div
          className="img"
          style={{
            backgroundImage: orderDetail.product.photoUrl
              ? `url(http://${orderDetail.product.photoUrl})`
              : `url(${noImage})`
          }}
        />
      </div>
      <div className="info-block">
        <div className="column-value name">
          <label>品名</label>
          <font>{orderDetail.product.name}</font>
        </div>
        <div className="column-value price">
          <label>售價</label>
          {orderDetail.unitPrice ? orderDetail.unitPrice : "待業務議價"}
        </div>
        <div className="column-value quantity">
          <label>數量</label>
          <div className="input-group mb-3">
            {props.justPreview ? (
              orderDetail.quantity
            ) : (
              <>
                <div className="input-group-prepend">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => {
                      if (checkQuantity(orderDetail.quantity - 1)) {
                        updateCartQuantity(index, orderDetail.quantity - 1)
                        updateToCart()
                      }
                    }}
                    disabled={props.readOnly}
                  >
                    <i className="fas fa-minus" />
                  </button>
                </div>
                <input
                  type="text"
                  className="form-control"
                  id={`txt_${orderDetail.product.id}`}
                  value={orderDetail.quantity}
                  onChange={e => {
                    if (
                      e.target.value.trim() !== "" &&
                      checkQuantity(
                        parseInt(e.target.value.replace(/\D/g, ""), 10)
                      )
                    ) {
                      updateCartQuantity(
                        index,
                        parseInt(e.target.value.replace(/\D/g, ""), 10)
                      )
                    }
                  }}
                  onBlur={() => {
                    updateToCart()
                  }}
                  disabled={props.readOnly}
                />
                <div className="input-group-prepend">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => {
                      if (checkQuantity(orderDetail.quantity + 1)) {
                        updateCartQuantity(index, orderDetail.quantity + 1)
                        updateToCart()
                      }
                    }}
                    disabled={props.readOnly}
                  >
                    <i className="fas fa-plus" />
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="column-value subtotal">
          <label>小計</label>
          {orderDetail.unitPrice ? orderDetail.sum : "待業務議價"}
        </div>

        {!props.justPreview && (
          <div className="column-value delete">
            <Button
              color="secondary"
              outline
              onClick={() => {
                updateCartQuantity(index, 0)
                updateToCart()
              }}
              disabled={props.readOnly}
            >
              <i className="far fa-trash-alt" />
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}

export default withBasicNotify(ShoppingCartItem)
